import React, {useContext, useState} from 'react';
import block from 'bem-cn-lite';
import {User} from '@gravity-ui/uikit';
import {useHoverCardHeader} from '@frontend/shared';
import {useMenuKeyboard} from '@hooks/keyboard';
import {UserCard} from './UserCard/UserCard';
import {ModalQuit} from '@components/ModalQuit';
import AvatarIcon from '@assets/avatar-icon.svg';
import {LoginAsClient} from './LoginAsClient/LoginAsClient';
import {SearchInput} from './SearchInput/SearchInput';
import {ClientSelect} from './ClientSelect/ClientSelect';
import {AppContext} from '@app/context/context';

import './Header.scss';

const b = block('main-header');

export const Header = () => {
    const {state, emit} = useContext(AppContext);
    const user = state.user;
    const [showModalQuit, setShowModalQuit] = useState(false);

    const {
        isVisible: isUserCardVisible,
        handleMouseEnter: handleMouseEnterUser,
        handleMouseLeave: handleMouseLeaveUser,
        hideUserCard
    } = useHoverCardHeader();

    const handleLogoutRequest = () => {
        hideUserCard();
        setShowModalQuit(true);
    };

    const {highlightedIndex: profileMenuIndex} = useMenuKeyboard({
        isOpen: isUserCardVisible,
        items: ['logout'] as const,
        onSelect: handleLogoutRequest,
        onClose: hideUserCard
    });

    const handleAvatarKeyDown = (event: React.KeyboardEvent) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            handleMouseEnterUser();
        }
        if (event.key === 'Escape') {
            hideUserCard();
        }
    };

    return (
        <header className={b()}>
            <div className={b('left-container')}>
                <div className={b('select')}>
                    <ClientSelect />

                    <LoginAsClient />
                </div>

                <SearchInput />
            </div>

            <div
                onMouseEnter={handleMouseEnterUser}
                onMouseLeave={handleMouseLeaveUser}
                onFocus={handleMouseEnterUser}
                onBlur={(event) => {
                    if (!event.currentTarget.contains(event.relatedTarget as Node)) {
                        handleMouseLeaveUser();
                    }
                }}
            >
                <div
                    className={b('avatar-trigger')}
                    role="button"
                    tabIndex={0}
                    aria-haspopup="menu"
                    aria-expanded={isUserCardVisible}
                    aria-label="Профиль"
                    onKeyDown={handleAvatarKeyDown}
                >
                    <User
                        className={b('avatar')}
                        avatar={{imgUrl: AvatarIcon}}
                        name={user?.displayName}
                        description={user?.email}
                        size="xl"
                    />
                </div>
                {isUserCardVisible && (
                    <UserCard
                        onClose={hideUserCard}
                        onLogoutRequest={handleLogoutRequest}
                        highlightedIndex={profileMenuIndex}
                    />
                )}
            </div>

            <ModalQuit
                visibility={showModalQuit}
                stateModal={setShowModalQuit}
                positiveAction={() => emit('logout', {redirectTo: '/'})}
            />
        </header>
    );
};
